module.exports = __webpack_public_path__ + "img/ic_available.0c5b8bf6.svg";